import React, { useState, createContext, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { HashRouter, Route, Routes } from 'react-router-dom';
import Navbar from './pages/navbar';
import DutiesAllotment from './pages/rolesmanagement';
import ProtectedRoutes from './components/protected/protected routes';
import Employees from './pages/employees';
import Leads from './pages/leads';
import Loginpage from './authentication pages/loginpage';
import '@fontsource/poppins';
import '@fontsource/open-sans'
import '@fontsource/inter'
import Forgotpasswordpage from './authentication pages/forgotpassowrd';
import Otpverificationpage from './authentication pages/verifyotppage';
import Changepassword from './authentication pages/changepassword';
import Tasks from './pages/tasks';
import Services from './pages/services';
import SettingsPage from './pages/settings';
import ClientsPage from './pages/clientsmanagement';
import Dashboard from './pages/dashboardpage';
import SalesPage from './pages/sales';
import axios from 'axios';
import { Navigate } from 'react-router-dom';
import { HashLoader } from 'react-spinners';
import LeadsMasterTypes from './components/masters/leadsmaster';
import ClientsMasterTypes from './components/masters/clientsmaster';
import EmployeeMasterTypes from './components/masters/employeemasters';
import PriorityAndCategoryMaster from './components/masters/orientation and services';
import LocationsMaster from './components/masters/locations';
import Cookies from 'js-cookie'
import Orientations from './pages/orientations';

export const AuthContext = createContext();

const Root = () => {
  const token = Cookies.get('token');
  const [authStatus, setAuthStatus] = useState(false);
  const [companyid, setCompanyid] = useState(true);
  const [companydata, setCompanydata] = useState({});
  const [loading, setLoading] = useState(true);
  const [isCEO, setIsCEO] = useState(false)
  const [selfOnly, setSelfOnly] = useState(false);
  const [employeeId, setEmployeeId] = useState(false);
  const [ceocompany, setCeocompany] = useState(false);
  const [loggedinEmail, setLoggedinEmail] = useState(null)
  const [permissions, setPermissions] = useState({
    employees: { create: false, read: false, update: false, delete: false },
    masters: { create: false, read: false, update: false, delete: false },
    bills: { create: false, read: false, update: false, delete: false }
  });

  const [trainersdata, setTrainersdata] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [permissionsLoading, setPermissionsLoading] = useState(true);


  const [employmentTypeData, setEmploymentTypeData] = useState([]);
  const [departmentData, setDepartmentData] = useState([]);
  const [salaryFrequencyData, setSalaryFrequencyData] = useState([]);
  const [preferredPaymentData, setPreferredPaymentData] = useState([]);
  const [paymentTermsData, setPaymentTermsData] = useState([]);

  const [sourceTypeData, setSourceTypeData] = useState([]);
  const [interestLevelData, setInterestLevelData] = useState([]);
  const [leadStageData, setLeadStageData] = useState([]);

  useEffect(() => {
    if (token) {
      setAuthStatus(true);
      authenticateddata();
    } else {
      setLoading(false);
      setAuthStatus(false);
    }
  }, [token]);
  const logout = async () => {
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_LINKS}/auth/logout`, {}, { withCredentials: true });
      if (res.status === 200) {
        Cookies.remove('token');
        setAuthStatus(false);
        setCompanyid('');
        setCompanydata({});
        setPermissions({
          employees: { create: false, read: false, update: false, delete: false },
          masters: { create: false, read: false, update: false, delete: false },
          bills: { create: false, read: false, update: false, delete: false },
          leads: { create: false, read: false, update: false, delete: false },
          clients: { create: false, read: false, update: false, delete: false },
          services: { create: false, read: false, update: false, delete: false },
          rolemanagement: { create: false, read: false, update: false, delete: false },
          followup: { create: false, read: false, update: false, delete: false },
          orientation: { create: false, read: false, update: false, delete: false }
        });
        setIsCEO(false);
        return true;
      }
    } catch (err) {
      console.error('Logout error:', err);
      setIsCEO(false);
      return false;

    }
  };

  const authenticateddata = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_LINKS}/tokendata/tokendata`, {
        withCredentials: true,
      });
      if (response.data.activitystatus) {
        setAuthStatus(true);
        // setCompanyid(response.data.companyid);
        setEmployeeId(response.data.employeeid);
        setLoggedinEmail(response.data.email);
        selfandreadonly()

      } else {
        setAuthStatus(false);
      }
    } catch (error) {
      setAuthStatus(false);
    } finally {
      setLoading(false);
    }
  };

  const companiesdata = async () => {
    // if (!companyid) return;

    try {
      const res = await axios.get(`${process.env.REACT_APP_API_LINKS}/tokendata/companydata/${companyid}`, {
        withCredentials: true,
      });

      if (res.status === 200) {
        setCompanydata(res.data);

      }
    } catch (err) {
      console.error('Company data error:', err);
    }
  };
  const modulepermissions = async () => {
    if (!companyid) return;
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_LINKS}/permissions/rolepermissions`, {
        headers:
        {
          Authorization: `bearer ${token}`
        },
        withCredentials: true
      });

      if (res.status === 250) {
        const fullAccess = {
          employees: { create: true, read: true, update: true, delete: true },
          masters: { create: true, read: true, update: true, delete: true },
          bills: { create: true, read: true, update: true, delete: true },
          leads: { create: true, read: true, update: true, delete: true },
          clients: { create: true, read: true, update: true, delete: true },
          services: { create: true, read: true, update: true, delete: true },
          rolemanagement: { create: true, read: true, update: true, delete: true },
          followup: { create: true, read: true, update: true, delete: true },
          orientation: { create: true, read: true, update: true, delete: true }
        };
        setIsCEO(true);
        setPermissions(fullAccess);
        return;
      }
      if (res.status === 200) {
        const data = res.data;

        const mappedPermissions = {
          employees: { create: false, read: false, update: false, delete: false },
          masters: { create: false, read: false, update: false, delete: false },
          bills: { create: false, read: false, update: false, delete: false },
          leads: { create: false, read: false, update: false, delete: false },
          clients: { create: false, read: false, update: false, delete: false },
          services: { create: false, read: false, update: false, delete: false },
          rolemanagement: { create: false, read: false, update: false, delete: false },
          followup: { create: false, read: false, update: false, delete: false },
          orientation: { create: false, read: false, update: false, delete: false }

        };

        data.forEach(item => {
          const key = item.module_name?.trim();
          if (key && mappedPermissions[key]) {
            mappedPermissions[key] = {
              create: item.can_write === 1,
              read: item.can_read === 1,
              update: item.can_update === 1,
              delete: item.can_delete === 1
            };
          } else {
            console.warn(`Unexpected module_name: "${item.module_name}"`);
          }
        });

        setPermissions(mappedPermissions);
        // console.log('Permissions set:', mappedPermissions);

        setIsCEO(false);
      }

    } catch (err) {
      console.log('Role permissions Error:', err);
    }
    finally {
      setPermissionsLoading(false)
    }
  };
  const Othersmaster = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_LINKS}/othersmaster/get`, {
        headers:
        {
          Authorization: `bearer ${token}`
        },
        withCredentials: true
      });
      if (res.status === 200 && res.data) {
        setTrainersdata(res.data.trainers || []);
        setCategoryData(res.data.serviceCategory || []);
      } else {
        console.warn('Unexpected response:', res);
      }
    } catch (err) {
      console.error('Error in service & tasks masters:', err);
    }
  };
  const employeemasters = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_LINKS}/employeemasters/get`,
        {
          headers: {
            Authorization: `bearer ${token}`
          },
          withCredentials: true
        }
      );
      if (res) {
        setEmploymentTypeData(res.data.employmentTypes || []);
        setDepartmentData(res.data.departments || []);
        setSalaryFrequencyData(res.data.salaryFrequencies || []);
      }
    }
    catch (err) {
      console.error('Error fetching data:', err);
    };
  }

  const clientsmaster = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_LINKS}/clientmasters/getclients `, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true
      })
      if (res) {
        setPreferredPaymentData(res.data.preferredPayment || []);
        setPaymentTermsData(res.data.paymentTerms || []);
      }
    }
    catch (err) {
      console.error('Error fetching data:', err);
    };
  }

  const leadsmasters = async () => {

    try {
      const res = await axios.get(`${process.env.REACT_APP_API_LINKS}/leadmasters/getleads`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true
        }
      )

      if (res) {
        setSourceTypeData(res.data.sourceType || []);
        setInterestLevelData(res.data.interestLevels || []);
        setLeadStageData(res.data.leadStages || []);
      }

    }
    catch (err) {
      console.error('Error fetching data:', err);
    };
  }
  const selfandreadonly = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_LINKS}/permissions/ceocompany`, {
        headers:
        {
          Authorization: `bearer ${token}`
        },
        withCredentials: true
      });
      if (res.status === 200) {
        setSelfOnly(res.data.selfOnly);
        setCeocompany(res.data.ceocompany)
      }
    }
    catch (err) {
      console.error('Error fetching data:', err);
    };


  }


  useEffect(() => {
    authenticateddata();
  }, []);

  useEffect(() => {
    // if (companyid) {
    companiesdata();
    modulepermissions();
    Othersmaster()
    employeemasters();
    clientsmaster();
    leadsmasters();
    // }/
  }, []);

  if (loading) {
    return <div style={{ fontFamily: 'poppins', padding: '2rem' }}><HashLoader /></div>;
  }

  return (
    <AuthContext.Provider value={{
      authStatus, companyid, companydata, permissions, trainersdata, categoryData, employmentTypeData, departmentData, salaryFrequencyData,
      preferredPaymentData, paymentTermsData, sourceTypeData, interestLevelData, leadStageData, logout, employeeId, selfOnly, ceocompany, isCEO, loggedinEmail, token
    }}>
      <HashRouter>
        <Routes>
          {/* Public routes */}

          {!authStatus && <><Route path="/login" element={<Loginpage />} />
            <Route path="/forgot" element={<Forgotpasswordpage />} />
            <Route path="/verifyotp" element={<Otpverificationpage />} />
            <Route path="/changepassword" element={<Changepassword />} />
          </>}

          {/* Protected routes */}
          <Route element={<ProtectedRoutes />}>
            <Route path="/" element={<Navbar />}>
              <Route index element={<Dashboard />} />
              {permissions?.rolemanagement?.read && <Route path="/duties" element={<DutiesAllotment />} />}
              {permissions?.clients?.read && <Route path="/clients" element={<ClientsPage />} />}
              {permissions?.employees?.read && <Route path="/employees" element={<Employees />} />}
              {permissions?.leads?.read && <Route path="/leads" element={<Leads />} />}
              {permissions?.orientation?.read && <Route path="/demo" element={<Orientations />} />}
              {permissions?.services?.read && <Route path="/services" element={<Services />} />}
              {permissions?.masters?.read && <Route path="/settings" element={<SettingsPage />} />}
              {permissions?.bills?.read && <Route path="/sales" element={<SalesPage />} />}
              {permissions?.masters?.read && <Route path="/masters/leads" element={<LeadsMasterTypes />} />}
              {permissions?.masters?.read && <Route path="/masters/clients" element={<ClientsMasterTypes />} />}
              {permissions?.masters?.read && <Route path="/masters/employees" element={<EmployeeMasterTypes />} />}
              {permissions?.masters?.read && <Route path="/masters/tasks&services" element={<PriorityAndCategoryMaster />} />}
              {permissions?.masters?.read && <Route path="/masters/locations" element={<LocationsMaster />} />}
              <Route path="*" element={<Navigate to="/" replace />} />

            </Route>
          </Route>
        </Routes>
      </HashRouter>
    </AuthContext.Provider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Root />);

reportWebVitals();
